import { render, staticRenderFns } from "./etiq.vue?vue&type=template&id=26aa222a"
import script from "./etiq.vue?vue&type=script&lang=js"
export * from "./etiq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports